import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Header, HeaderTitle } from 'components/layout';
import AreasListTable from './AreasListTable';

const AreasList = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const areas = useSelector(state => state.referenceData.areas);
  const navigate = useNavigate();
  const toggleNavigation = () => {
    setShowOverlay(prev => !prev);
  };

  const options = {
    onRowClick: (row) => {
      navigate(`/areas/${row.id}`);
    }
  };

  return (
    <div>
      <Header showLogo>
        <HeaderTitle label="Areas" />
      </Header>
      <AreasListTable options={options} areas={areas} />
    </div>
  );
};

export default AreasList;
